import { render, staticRenderFns } from "./UltimateBeneficialOwner.vue?vue&type=template&id=5029b01a&scoped=true"
import script from "./UltimateBeneficialOwner.vue?vue&type=script&lang=js"
export * from "./UltimateBeneficialOwner.vue?vue&type=script&lang=js"
import style0 from "./UltimateBeneficialOwner.vue?vue&type=style&index=0&id=5029b01a&prod&scoped=true&lang=css"
import style1 from "./UltimateBeneficialOwner.vue?vue&type=style&index=1&id=5029b01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029b01a",
  null
  
)

export default component.exports